import api from '@/apiManager/apiManager'

export const getAllChallenges = data => {
  // challengeType filters by metric (step, distance, star_jump …). It has to go
  // to the server: the listing is paginated, so filtering here would only filter
  // the page already loaded.
  const challengeType = data.challengeType && data.challengeType !== 'all'
    ? `&challengeType=${encodeURIComponent(data.challengeType)}`
    : ''
  const url = `/corporate-admin/gamification/challenges?limit=${data.limit}&offset=${data.offset}&type=${data.type}&currentDate=${data.currentDate}${challengeType}`
  return api('get', url, '', 'base')
}

export const createChallenge = data => {
  const url = '/corporate-admin/gamification/challenge'
  return api('post', url, data, 'base')
}

export const updateChallenge = (data, id) => {
  const url = `/corporate-admin/gamification/challenge/${id}`
  return api('patch', url, data, 'base')
}

export const deleteChallenge = (id, userId) => {
  const url = `/corporate-admin/gamification/challenge/${id}/${userId}`
  return api('delete', url, '', 'base')
}

// Accepted / pending Terms & Conditions counts. `id` is the _id or slug.
export const getChallengeTermsStats = id => {
  const url = `/corporate-admin/gamification/challenge/${id}/terms-stats`
  return api('get', url, '', 'base')
}

export const addChallengeParticipants = (challengeId, userIds) => {
  const url = `/corporate-admin/gamification/challenge/${challengeId}/participants`
  return api('post', url, { userIds }, 'base')
}

// Approve / decline a join request. These live on the gamification service
// (same base as getChallengeInvites), not corporate-admin — corporate-admin has
// no invite routes at all. Both act on a single user, so bulk approve/decline
// has to be fanned out by the caller.
export const approveChallengeJoinRequest = data => {
  const url = `/add-user-to-challenge/${data.userId}`
  return api('post', url, { challengeId: data.challengeSlug }, 'gamification')
}

export const declineChallengeJoinRequest = data => {
  const url = `/remove-user-to-challenge/${data.userId}`
  return api('post', url, { challengeSlug: data.challengeSlug }, 'gamification')
}

export const deleteBooking = data => {
  const url = `/corporate-admin/gamification/participants/${data.id}?challengeId=${data.challengeId}`
  return api('delete', url, '', 'base')
}
// leader board
export const getChallengeById = data => {
  const url = '/get-challenge-by-id'
  return api('post', url, data, 'gamification')
}

export const getChallengeParticipants = data => {
  const url = '/get-challenge-participants'
  return api('post', url, data, 'gamification')
}

export const getChallengeInvites = data => {
  const url = '/get-challenge-invites'
  return api('post', url, data, 'gamification')
}

export const getTopTenChallenges = () => {
  const url = '/corporate-admin/gamification/top-ten-gamification-challenge'
  return api('get', url, '', 'base')
}
export const csvExportChallengeParticipants = data => {
  const url = `/corporate-admin/gamification/gamification-challenges/${data.slug}/export/csv`
  return api('get', url, '', 'base')
}

export const getChallengeTypes = data => {
  const url = `/challenge-category-types`
  return api('get', url, '', 'gamification')
}
